import { compose } from 'lodash/fp';
import { createDateFeatureMiddleware } from './date';
import { FeatureMiddleware } from '../featureInterface';
import { createFilterFeatureMiddleware } from './filter';

export function createFeatureQueryMiddleware(): FeatureMiddleware[] {
    return [createDateFeatureMiddleware(), createFilterFeatureMiddleware()];
}
